export default __webpack_public_path__ + "assets/bb9cfe88ce572f71a43193bed56b52d6.ttf";